import React from 'react';
import PresentationForm from "../../forms/abstract/PresentationForm";
import {Card} from "@mui/material";

export default function PresentationPane(props) {

    const [complete, setComplete] = React.useState(false);

    return (
        <React.Fragment>
            <div style={{
                maxWidth: "800px",
                marginLeft: "auto",
                marginRight: "auto",
                padding: "20px"
            }}>
                <Card>
                    <div>
                        {complete ? <div style={{margin: "30px"}}>
                                        <div style={{color: "black"}}>
                                            <span className={"default-font-xxlarge"}>Thank you for your submission!</span>
                                            <div className={"default-font-color-dark default-margin-top-medium"}>
                                                If any additional information is required,
                                                you will be contacted at the email you provided at registration.
                                            </div>
                                            <div className={"default-font-color-dark default-margin-top-medium default-font-bold"}>
                                                We will see you on the 6th of November!
                                            </div>
                                        </div>
                                    </div> :
                            <PresentationForm onComplete={()=>setComplete(true)}  key={"pp_"+Date.now()}/>
                        }
                    </div>
                </Card>

            </div>
        </React.Fragment>
    )
}